import {
  Divider,
  getBreakPoint,
  Modal,
  SANS_3,
  UI_BODY_BOLD,
  UI_BODY_SEMIBOLD,
  useScreenWidth,
} from "oolib";
import React from "react";

import NotificationContent from "../NotificationContent";
import { NotificationBoxStyled, NotificationBoxTitleStyled,NotificationBoxHeaderStyled } from "./styled";
import { _Locale } from "../../../../../../../../locale/Locale";
import { useHeaderHeight } from "@/CONSTANTS";

export default function NotificationBox({
  data,
  title = "Notifications",
  onClick,
}) {
  const screenWidth = useScreenWidth();

  const isMobile = screenWidth <= getBreakPoint("md"); //  create a custom hook?
  
  const headerHeight = useHeaderHeight();

  return isMobile ? (
    <Modal title={_Locale(title)} onClose={onClick}>
      <NotificationContent data={data} />
    </Modal>
  ) : (
    <NotificationBoxStyled headerHeight={headerHeight}>
      <NotificationBoxHeaderStyled>
      <NotificationBoxTitleStyled>
        <UI_BODY_BOLD>
        {title}
        </UI_BODY_BOLD>
      </NotificationBoxTitleStyled>
      <div style={{ padding: "0 1rem" }}>
        {" "}
        <Divider />
      </div>
      </NotificationBoxHeaderStyled>
      <NotificationContent onClick={onClick} data={data} />
    </NotificationBoxStyled>
  );
}
